import { useState, useCallback } from 'react';
import { ModalView } from '../types';

export interface EntityAnalysisModalNavigationState {
  currentView: ModalView;
  selectedFindingIndex: number | null;
  navigateTo: (view: ModalView, findingIndex?: number) => void;
  goBackToMain: () => void;
}

export const useEntityAnalysisModalNavigation =
  (): EntityAnalysisModalNavigationState => {
    const [currentView, setCurrentView] = useState<ModalView>(ModalView.Main);
    const [selectedFindingIndex, setSelectedFindingIndex] = useState<
      number | null
    >(null);

    const navigateTo = useCallback((view: ModalView, findingIndex?: number) => {
      setCurrentView(view);
      if (findingIndex !== undefined) {
        setSelectedFindingIndex(findingIndex);
      }
    }, []);

    const goBackToMain = useCallback(() => {
      setCurrentView(ModalView.Main);
      setSelectedFindingIndex(null);
    }, []);
    return {
      currentView,
      selectedFindingIndex,
      navigateTo,
      goBackToMain,
    };
  };
